import { apiClient } from '@api/api-client'
import { setRequestOrganizationId } from '@api/request-correlation'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from './use-auth'

export const useSubmitSignin = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { loadUser, setLoading } = useAuth()

  const [error, setError] = useState('')

  const from =
    [location.state?.from?.pathname, location.state?.from?.search]
      .filter(Boolean)
      .join('') || '/'

  const submit = async ({ organizationId, password }) => {
    try {
      setLoading(true)
      const normalizedOrganizationId = organizationId.trim()

      await apiClient.get('/auth/external-token', {
        params: { org_id: normalizedOrganizationId },
        headers: {
          Authorization: `Bearer ${password}`,
          'X-Organization-Id': normalizedOrganizationId,
        },
      })

      setRequestOrganizationId(normalizedOrganizationId)
      await loadUser({ throwOnError: true })
      navigate(from, { replace: true })
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return { submit, error }
}
